import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var CancelError = /*#__PURE__*/function (_Error) {
  _inherits(CancelError, _Error);
  var _super = _createSuper(CancelError);
  function CancelError() {
    var _this;
    _classCallCheck(this, CancelError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "isCancelled", true);
    return _this;
  }
  return _createClass(CancelError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var CANCEL_ERROR = new CancelError('Promise is cancelled');
export var CancellablePromise = /*#__PURE__*/function () {
  function CancellablePromise(promise) {
    var _this2 = this;
    _classCallCheck(this, CancellablePromise);
    _defineProperty(this, "cancelInternal", function () {
      // Default throws an error as this should never happen
      throw new Error('Programming error, cancelling promise is not properly rejected');
    });
    _defineProperty(this, "promise", function () {
      return _this2.cancellablePromiseInternal;
    });
    _defineProperty(this, "cancel", function () {
      return _this2.cancelInternal();
    });
    this.cancellablePromiseInternal = Promise.race([promise, new Promise(function (_, reject) {
      _this2.cancelInternal = function () {
        return reject(CANCEL_ERROR);
      };
    })]);
  }
  _createClass(CancellablePromise, null, [{
    key: "from",
    value: function from(promise) {
      return new CancellablePromise(promise);
    }
  }]);
  return CancellablePromise;
}();